/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import { Grid, Box } from '@mui/material';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import ModalFooter from '../../CustomModal/ModalFooter';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import _ from 'lodash';
import { toast } from 'react-hot-toast';
import CompDirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allEmpDocTypes: [];
  allCountires: [];
  callBackGetData: (data: any) => void;
  trans?: any;
}
const AddDocsModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allEmpDocTypes,
  allCountires,
  trans,
}: ModalProps) => {
  const [document_type, setdocument_type] = useState('');
  const [countryName, setCountryName] = useState('');
  const [, setCountryId] = useState();
  const [EmpDocTypeId, setEmpDocTypeId] = useState();
  const [identifierNo, setIdentifierNo] = useState('');
  const [remarks, setRemarks] = useState('');
  const [issueDate, setissueDate] = useState<any>(new Date());
  const [expiredDate, setExpiredDate] = useState<any>(new Date());

  const [proofAttachment, setProofAttachment] = useState(null);
  const [proofAttachmentPath, setProofAttachmentPath] = useState('');
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [newattachement, setNewAttachement] = useState(false);

  const [showReferenceNo, setShowReferenceNo] = useState(false);
  const [showAddReferenceNo, setShowAddReferenceNo] = useState(false);
  const [referenceNo, setReferenceNo] = useState('');
  const [addReferenceNo, setAddReferenceNo] = useState('');
  const [showExpiryDate, setShowExpiryDate] = useState(false);

  const Handledocumenttype = (document_type: any) => {
    const EmpDocTypes = _.filter(allEmpDocTypes, function (c: any) {
      return c.type === document_type;
    });
    if (EmpDocTypes.length) {
      const empdocty = EmpDocTypes[0];
      setEmpDocTypeId(empdocty.id);
      setdocument_type(document_type);

      if (empdocty.reference_number_required == 1) {
        setShowReferenceNo(true);
      } else {
        setShowReferenceNo(false);
      }

      if (empdocty.additional_reference_number_required == 1) {
        setShowAddReferenceNo(true);
      } else {
        setShowAddReferenceNo(false);
      }

      if (empdocty.expiry_date_required == 1) {
        setShowExpiryDate(false);
        setExpiredDate(new Date());
      } else {
        setExpiredDate('');
        setShowExpiryDate(true);
      }
    }
  };
  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      setCountryName(countryName);
    }
  };

  const attachmentUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;

      setProofAttachment(image_as_files);
      setProofAttachmentPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setProofAttachment(file);
    }
  };
  const handleSubmit = () => {
    callBackGetData({
      documentTypeId: EmpDocTypeId,
      countryName: countryName,
      issueDate: issueDate,
      expiredDate: expiredDate,
      identifierNo: identifierNo,
      remarks: remarks,
      file: proofAttachment,
      newattachement: newattachement,
      showReferenceNo: showReferenceNo,
      showAddReferenceNo: showAddReferenceNo,
      referenceNo: referenceNo,
      addReferenceNo: addReferenceNo,
      showExpiryDate: showExpiryDate,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Add Documents') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '10px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Document Type')}
              value={document_type}
              options={_.map(allEmpDocTypes, (EmpDoctype: any) => {
                return EmpDoctype.type;
              })}
              onChange={(event: any, newValue: any) => {
                Handledocumenttype(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Issue Country')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={countryName}
              onChange={(event: any, newValue: any) => {
                handleSetCounty(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Issue Date')}
              value={new Date(issueDate)}
              width="100%"
              onChange={(newValue: any) => {
                if (!showExpiryDate && newValue && newValue > expiredDate) {
                  toast.error(
                    trans('Expiry date must be greater then issue date'),
                  );
                } else {
                  setissueDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Expire Date')}
              width="100%"
              value={expiredDate}
              disabled={showExpiryDate}
              onChange={(newValue: any) => {
                if (!showExpiryDate && issueDate && issueDate > newValue) {
                  toast.error(
                    trans('Expiry date must be greater then issue date'),
                  );
                } else {
                  setExpiredDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Identifier Number')}
              placeholder={trans('Identifier Number')}
              value={identifierNo}
              onChange={(e: any) => setIdentifierNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Remarks')}
              placeholder={trans('Write Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>
          {showReferenceNo ? (
            <Grid item xs={6} style={{ marginTop: '0.5em' }}>
              <CustomTextField
                type=""
                label={trans('Reference No.')}
                placeholder={trans('Reference No.')}
                value={referenceNo}
                onChange={(e: any) => setReferenceNo(e.target.value)}
              />
            </Grid>
          ) : (
            <></>
          )}
          {showAddReferenceNo ? (
            <Grid item xs={6} style={{ marginTop: '0.5em' }}>
              <CustomTextField
                type=""
                label={trans('Additional Reference No.')}
                placeholder={trans('Additional Reference No.')}
                value={addReferenceNo}
                onChange={(e: any) => setAddReferenceNo(e.target.value)}
              />
            </Grid>
          ) : (
            <></>
          )}
          <Grid item xs={12} style={{ marginTop: '0.5em', flexGrow: 1 }}>
            <Grid item xs={6}>
              <DropAndSelect
                upload={attachmentUpload}
                src={proofAttachmentPath}
                isAttachmentSigned={true}
                isPDF={isPDF}
                pdfName={pdfName}
                onDelete={() => {
                  setPDFName('');
                  setIsPDF(false);
                  setProofAttachmentPath('');
                  setNewAttachement(false);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </CompDirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default AddDocsModalPresenter;
